import { useEffect, useRef, type FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { Head, usePromoForm, usePromoUpload } from '@features/promo-videos';
import { ArrowShortLeft } from '@shared/assets';
import {
  IconButton,
  ListBody,
  PageHead,
  PageTitle,
  TextButton,
  UploadProgressCard,
} from '@shared/ui';
import { FormVideo } from '@shared/ui/forms/video/index.ts';
import * as st from './styles.module.scss';
import { useOneVideoSelect } from '@shared/ui/forms/video/helpers.ts';

type Props = {
  videoId: number;
  onCancel?: () => void;
  onSuccess?: (id: number) => void;
  selectedFromLibrary?: number;
};

export const PromoForm: FC<Props> = ({ videoId, onCancel, onSuccess }) => {
  const { methods, hasDirtyFields } = usePromoForm(videoId);
  const titleOrScreenshotUrlRef = useRef<HTMLFieldSetElement>(null);
  const { onSubmit, uploadStatus, progress, doAbortLoading } = usePromoUpload(
    videoId,
    onCancel,
    onSuccess
  );
  // console.log('errors:', methods.formState.errors);
  const isSubmitDisabled = !hasDirtyFields;
  // const isSubmitDisabled = false;

  const errors = methods.formState.errors;

  useEffect(() => {
    if (errors?.title || errors?.screenshot_url) {
      titleOrScreenshotUrlRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [errors]);

  return (
    <>
      <FormProvider {...methods}>
        <form className={st.video} onSubmit={methods.handleSubmit(onSubmit)}>
          <PageTitle title={isNaN(videoId) ? 'Трейлер' : 'Редактирование трейлера'} />
          <PageHead
            Left={
              <IconButton variant="dark" onClick={onCancel}>
                <ArrowShortLeft />
              </IconButton>
            }
            Right={
              uploadStatus === 'loading' ? (
                <TextButton type="button" onClick={doAbortLoading}>
                  Отмена
                </TextButton>
              ) : (
                <TextButton type="submit" disabled={isSubmitDisabled}>
                  Готово
                </TextButton>
              )
            }
          />
          {uploadStatus === 'idle' && (
            <ListBody>
              <section className={st.video__body}>
                <Head fieldRef={titleOrScreenshotUrlRef} />

                <FormVideo fieldLabel={''} isDisabledSelectionFromLibrary={true}/>
              </section>
            </ListBody>
          )}
          {uploadStatus === 'loading' && (
            <UploadProgressCard progress={progress} className={st.progress} />
          )}
        </form>
      </FormProvider>
    </>
  );
};
